import CookiesAdapter from "./Cookies";
import { _ } from "../../vendor";

const LocalStorageAdapter = new (class {
  documentHasCookies() {
    return localStorage.length >= 1;
  }

  /**
   * @param {String} key
   * @return String which is empty if null
   */
  get(key: any): string {
    const r: any = localStorage.getItem(key);
    return r === null ? "" : r;
  }

  set(key: any, val: any, __: any): void {
    localStorage.setItem(key, val);
  }

  delete(key: any): void {
    localStorage.removeItem(key);
  }

  deleteAll(): void {
    localStorage.clear();
  }
})();

const Adapters: any = {
  cookies: CookiesAdapter,
  localStorage: LocalStorageAdapter,
};

/**
 * @class Biscuit
 *
 * Works as an intermediary between the two CRUD-adapters,
 * localStorage and Cookies.
 *
 * Although localStorage is used in 99.9% of all cases,
 * we'll keep the opportunity to use this class for setting cookies
 * via the same interface as well (e.g in future we could save
 * the auth-token as a cookie to enable server-side authentication
 * via Cake middleware before index.html is then returned by webserver).
 */
export default new (class {
  constructor() {
    // @ts-ignore
    this._adapter = Adapters.localStorage;
  }

  /**
   * Changes the local adapter
   * ATTENTION: Remember to reset the adapter after your action is finished
   * e.g. Biscuit.changeAdapter('cookies')
   *             .set(...)
   *             .changeAdapter('localStorage')
   *
   * @param {String} adapter
   */
  changeAdapter(adapter: any): this | undefined {
    if (typeof Adapters[adapter] == "undefined") {
      console.log("Error in Biscuit.js: Unknown adapter");
      return;
    }

    // @ts-ignore
    this._adapter = Adapters[adapter];

    return this;
  }

  documentHasCookies(): any {
    // @ts-ignore
    return this._adapter.documentHasCookies();
  }

  get(a: any): any {
    // @ts-ignore
    return this._adapter.get(a);
  }

  set(a: any, b: any, c?: any): this {
    // @ts-ignore
    this._adapter.set(a, b, c);
    return this;
  }

  delete(a: any): this {
    // @ts-ignore
    this._adapter.delete(a);
    return this;
  }

  deleteAll(): this {
    // @ts-ignore
    this._adapter.deleteAll();
    return this;
  }

  /**
   * @function getClientCurrency
   * Get client's currency as symbol
   * Left it here till we got an
   *
   * @return {String} e.g. € / $ / CHF
   */
  getClientCurrency(): string {
    // @ts-ignore
    switch (this._adapter.get("client.currency")) {
      case "EUR":
        return "€";

      case "CHF":
        return "CHF";

      case "USD":
        return "$";

      default:
        return "€";
    }
  }
})();
